import { Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './ExpandButton.css';

export type ExpandButtonProps = {
  isCollapsed: boolean,
  onClick: () => void,
};

export const ExpandButton = ({ isCollapsed, onClick }: ExpandButtonProps) => (
    <div className={styles.expand} onClick={onClick} role="button" tabIndex={0}>
      <div className={styles.expandButton} data-test-id="dmb-expand-split-view">
        {isCollapsed ? (
          <div>
            <Icon glyph={Icon.set.ARROW_UP} />
            {getMessage('expand')}
          </div>
        ) : (
          <div>
            <Icon glyph={Icon.set.ARROW_DOWN} />
            {getMessage('collapse')}
          </div>
        )}
      </div>
    </div>
  );
